module.exports = __webpack_public_path__ + "img/login-bg-v1_27June.46213247.jpg";